import { defineMessages } from 'react-intl';

export default defineMessages({
  downloadingDocuments: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.downloadingDocuments',
    defaultMessage: 'Downloading documents',
    description: 'Bulk request to prepare applicant documents for download',
  },
  requested: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.requested',
    defaultMessage: 'Requested',
    description:
      'The document export request is accepted, but its files are not ready yet',
  },
  documentExportApplicants: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.documentExportApplicants',
    defaultMessage:
      '{name} · {count, number} {count, plural, one {applicant} other {applicants}}',
    description:
      'Name of the document export requester and number of selected applicants',
  },
  documentExportEmail: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.documentExportEmail',
    defaultMessage: "We'll email you when the zip is ready.",
    description:
      'Document export files become available after preparation finishes',
  },
  openDocumentDownloads: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.openDocumentDownloads',
    defaultMessage: 'Open document downloads',
    description: 'Open the page listing applicant document exports',
  },
  clear: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.clear',
    defaultMessage: 'Clear',
  },
  errorCount: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.errorCount',
    defaultMessage: `{count} {count, plural, one {error} other {errors}} while performing action`,
  },
  errorLoadingApplicants: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.errorLoadingApplicants',
    defaultMessage: 'error loading applicants',
  },
  left: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.left',
    defaultMessage: 'left',
  },
  loadingApplicants: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.loadingApplicants',
    defaultMessage: 'loading applicants',
  },
  pause: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.pause',
    defaultMessage: 'Pause',
  },
  resume: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.resume',
    defaultMessage: 'Resume',
  },
  deletingApplicants: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.deletingApplicants',
    defaultMessage: 'Deleting Applicants',
  },
  rejectingApplicants: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.rejectingApplicants',
    defaultMessage: 'Rejecting Applicants',
  },
  sendingEmail: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.sendingEmail',
    defaultMessage: 'Sending Email',
  },
  sendingSms: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.sendingSms',
    defaultMessage: 'Sending SMS',
  },
  assigningTo: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.assigningTo',
    defaultMessage: 'Assigning to',
  },
  movingTo: {
    id: 'app.containers.BulkActionQueue.components.BulkActionQueuedItem.movingTo',
    defaultMessage: 'Moving to',
  },
});
